import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

const quotes = [
  {
    text: 'We planted a tree for our mother the year we lost her. Every spring I get a photo of its mangoes. It is the most tender correspondence I have with grief.',
    name: 'Ritika S.',
    role: 'Pune · Lifetime Tree gifted 2023',
  },
  {
    text: 'Gifted Pallavit Care trees to my team instead of Diwali hampers. A year later, three of them drove down to Nashik to meet their tree. Nothing we have sent has ever landed like this.',
    name: 'Karan M.',
    role: 'HR Lead, SaaS company · Bengaluru',
  },
  {
    text: 'My son was born during the pandemic. We could not have a naming ceremony — so we named a chikoo tree after him instead. It grows faster than he does.',
    name: 'Aanya & Devansh',
    role: 'Mumbai · Family Grove, 2022',
  },
];

export default function Testimonials() {
  return (
    <section className="bg-brand-bg py-28 md:py-36" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-14">
          <p className="text-brand-gold tracking-[0.25em] uppercase text-xs mb-5 font-medium">Quiet letters</p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-brand-ink leading-[1.05] tracking-tight font-light">
            Words from <em className="text-brand-forest">people with trees.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {quotes.map((q, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              className="rounded-3xl bg-brand-bg2 border border-brand-line p-8 flex flex-col h-full"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="w-6 h-6 text-brand-gold mb-5" />
              <blockquote className="font-serif text-lg text-brand-ink leading-relaxed italic flex-1">
                "{q.text}"
              </blockquote>
              <figcaption className="mt-6 pt-6 border-t border-brand-line">
                <div className="font-serif text-base text-brand-forest">{q.name}</div>
                <div className="text-brand-ink2 text-xs tracking-wide mt-0.5">{q.role}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
